import { render, staticRenderFns } from "./ChannelBadgeStatus.vue?vue&type=template&id=7722fa06&scoped=true&"
import script from "./ChannelBadgeStatus.vue?vue&type=script&lang=js&"
export * from "./ChannelBadgeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBadgeStatus.vue?vue&type=style&index=0&id=7722fa06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7722fa06",
  null
  
)

export default component.exports